package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_03_31_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We rejoin our heroes who had just entered the small cross road village of Blave. Our heroes enter the Cray’s Nest Tavern and Inn. The tavern is small, just 4 tables. Above the tavern are two rooms for rent, each of which can hold 4 people. An additional larger room attached to the adjacent stables holds 9-10 people.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Searah, the inn keeper, is a blond human woman about 45 years old. Our heroes later learn that her family runs inns throughout the western Malusian empire.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Searah - Blave - Cray’s Nest")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Toby and his son Jeeban - Darv - The Wheel")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Racken Forehammer - Dorb")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Jeeban refers to the family as “The Courthammers.”")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes are unsettled by how quiet the town is. Gorem inquires at the military outpost. It turns out that a number of Ettin and Hill Giants have descended from the hills near Lozdan and are harassing the locals. While the border guards continue to patrol the Malusian border, as our heroes experienced when they crossed the border, troops which are normally stationed in small towns in the area like Blave have been called in to assist with the Giantkin.  This has happened quite recently in that some of the further away towns’ soldiers have not yet arrived in the troubled area.  Additionally, only the initial reports of the trouble with the Giantkin have reached the villages. Nobody has heard back yet after the reinforcements arrived.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes go shopping at the vendor tents but don’t find anything particularly interesting.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Given the ongoing security threats, our heroes decide to continue to take watch duty turns, even though they are in town.")
    }
}
